import React from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { trans } from '../../../localization/language';
import { EMAIL_VERIFICATION_ENABLED_ACCOUNT_TYPES, VERIFICATION_TOOL, ACTION_TYPE, ACCOUNT_TYPE } from '../../../constants';
import EmailVerification from '../verification/EmailVerification';
import OtpVerification from '../verification/OtpVerification';
import AuthenticatorVerification from '../verification/AuthenticatorVerification';
import AlternativeTools from '../verification/AlternativeTools';
import { getFullMobileNo } from '../../../utils';

class TwoStepVerification extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			currentTool: VERIFICATION_TOOL.MOBILE,
			ac_type: props.ac_type
		};
	}

	componentWillMount() {
		if (!this.props.verification.current_action || this.props.verification.current_action.action_type !== ACTION_TYPE.TWO_STEP_VERIFICATION) {
			browserHistory.push('/security');
			return;
		}
		this.updateVerificationTool(this.props.userInfo);
	}

	emailVerifyAvailable(userInfo) {
		if (!userInfo.email_verify_available) return false;
		if (!EMAIL_VERIFICATION_ENABLED_ACCOUNT_TYPES.includes(this.state.ac_type)) return false;
		if (userInfo.acc_country === 'VN' && this.state.ac_type === ACCOUNT_TYPE.MOBILE) return false;
		return true;
	}

	mobileVerifyAvailable(userInfo) {
		if (!userInfo.mobile_no) return false;
		if (this.state.ac_type === ACCOUNT_TYPE.REALINFO) return false;
		return true;
	}

	authenticatorVerifyAvailable(userInfo) {
		if (!userInfo.authenticator_enable) return false;
		if (this.state.ac_type === ACCOUNT_TYPE.REALINFO) return false;
		if (userInfo.acc_country === 'VN' && this.state.ac_type === ACCOUNT_TYPE.MOBILE && userInfo.mobile_no) return false;
		return true;
	}

	updateVerificationTool(userInfo) {
		if (this.authenticatorVerifyAvailable(userInfo)) {
			this.setState({
				currentTool: VERIFICATION_TOOL.AUTHENTICATOR
			});
		} else if (this.emailVerifyAvailable(userInfo)) {
			this.setState({
				currentTool: VERIFICATION_TOOL.EMAIL
			})
		}
	}

	render() {
		const full_mobile_no = getFullMobileNo(this.props.userInfo);
		var email = this.props.userInfo.email;
		var VerificationPage = <OtpVerification mobile_no={full_mobile_no} ac_type={this.props.ac_type} />;
		if (this.state.currentTool === VERIFICATION_TOOL.AUTHENTICATOR) {
			VerificationPage = <AuthenticatorVerification ac_type={this.props.ac_type}/>;
		}
		if (this.state.currentTool === VERIFICATION_TOOL.EMAIL) {
			VerificationPage = <EmailVerification email={email} ac_type={this.props.ac_type} />;
		}
		var VerificationTools = null;

		var alternativeTools = []
		const userInfo = this.props.userInfo;
		if (this.authenticatorVerifyAvailable(this.props.userInfo) &&
			this.state.currentTool !== VERIFICATION_TOOL.AUTHENTICATOR) {
			alternativeTools.push(VERIFICATION_TOOL.AUTHENTICATOR);
		}
		if (this.emailVerifyAvailable(this.props.userInfo) &&
			this.state.currentTool !== VERIFICATION_TOOL.EMAIL) {
			alternativeTools.push(VERIFICATION_TOOL.EMAIL);
		}
		if (this.mobileVerifyAvailable(this.props.userInfo) && this.state.currentTool !== VERIFICATION_TOOL.MOBILE) {
			alternativeTools.push(VERIFICATION_TOOL.MOBILE);
		}

		if (alternativeTools.length) {
			VerificationTools = <AlternativeTools alternativeTools={alternativeTools} handleChangeTool={this.handleChangeTool.bind(this)} />
		}

		return (
			<div className="content">
				<div className="content-item content-item--ipage">
					<div className="content-item__title">
						{this.props.title}
					</div>
					{VerificationPage}
					<div className="content-item__main">
						<div className="content-item--ipage__main">
							{VerificationTools}
						</div>
					</div>
				</div>
			</div>
		);
	}

	handleChangeTool(verificationTool) {
		this.setState({
			currentTool: verificationTool
		})
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		verification: state.verification
	}
}

export default connect(mapStateToProps)(TwoStepVerification);


// WEBPACK FOOTER //
// ./app/components/security/verification/TwoStepVerification.js